import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar } from '@angular/material';
import { AdminService } from '../services/admin.service';
import { ProfileService } from '../profile.service';

@Injectable({
  providedIn: 'root'
})
export class LogService {

  constructor( 
    private router:Router,
    private http: HttpClient, 
    public snackBar: MatSnackBar, 
    private adminService: AdminService,
    private profileService: ProfileService,
  ){ 

  }
  private profile = this.profileService.getLSGG();

  msgInfo001 = "Save Complete Total : ";
  msgInfo002 = "Save Complete !";
  msgInfo003 = "Remove Complete !";
  msgInfo004 = "Delete Complete !";

  msgWarn0001 = "Please select date !";
  msgWarn0002 = "Please select date after ";
  msgWarn0003 = "Please select MONTH ";
  msgWarn0004 = "Please select YEAR ";
  msgWarn0005 = "Please fill the ";
  msgWarn0006 = "Admin not allowed !";
  msgWarn0007 = "Duplicate data !";
  msgWarn0008 = "No change found!";
  msgWarn0009 = "User already in non Admin group!";
  msgWarn0010 = "Please import valid .csv file.";
  msgWarn0011 = "No data in .csv file.";
  msgWarn0012 = "Data format mismatch!";
  msgWarn0013 = "Legal status not available";
  msgWarn0014 = "Collateral not found";
  msgWarn0015 = "Estimation not found";
  msgWarn0016 = "Date not in range";
  

  msgErr001 = "Data not found !";
  msgErr002 = "Data not unique !";
  msgErr003 = "Invalid Data format";
  msgErr004 = "Data not match on line ";
  msgErr005 = "Condition not match ";

  btnTitle1 = "Close";

  SYSTEM = "SYSTEM";
  AUTO   = "AUTO";

  LOG_ACTION = {
    ACCESS   : "ACCESS",
    INSERT   : "INSERT",
    SEARCH   : "SEARCH",
    MODIFY   : "MODIFY",
    DELETE   : "DELETE",
    ASSIGN   : "ASSIGN",
    UNASSIGN : "UNASSIGN",
    REMOVE   : "REMOVE",
    IMPORT   : "IMPORT",
    EXPORT   : "EXPORT",
    DOWNLOAD : "DOWNLOAD",
    RENAME   : "RENAME",
    TRANSFER : "TRANSFER",
    RPT_PDF  : "REPORT-PDF",
    RPT_EXL  : "REPORT-EXCEL",
    RESET    : "RESET",
  }

  SCREEN = {
    //--
    SCRN_ADM_GRP:{
      ID      : "SCRN-ADM-GRP",
      NAME    : "User Group",
      RGT_MOD : this.adminService.ACCESS_RIGHT.ADMIN.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.ADMIN.RIGHT.GROUP.ID
    },
    SCRN_ADM_GRP_MEM:{
      ID      : "SCRN-ADM-GRP-MEM",
      NAME    : "Group Member",
      RGT_MOD : this.adminService.ACCESS_RIGHT.ADMIN.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.ADMIN.RIGHT.MEMBER.ID
    },
    SCRN_ADM_RGT:{
      ID      : "SCRN-ADM-RGT",
      NAME    : "Access Right",
      RGT_MOD : this.adminService.ACCESS_RIGHT.ADMIN.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.ADMIN.RIGHT.RIGHT.ID
    },
    SCRN_ADM_USR:{
      ID      : "SCRN-ADM-USR",
      NAME    : "User",
      RGT_MOD : this.adminService.ACCESS_RIGHT.ADMIN.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.ADMIN.RIGHT.USER.ID
    },
    SCRN_ADM_LOG:{
      ID      : "SCRN-ADM-LOG",
      NAME    : "Log",
      RGT_MOD : this.adminService.ACCESS_RIGHT.ADMIN.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.ADMIN.RIGHT.LOG.ID
    },
    SCRN_ADM_NOTI:{
      ID      : "SCRN-ADM-NOTI",
      NAME    : "Notification",
      RGT_MOD : this.adminService.ACCESS_RIGHT.ADMIN.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.ADMIN.RIGHT.NOTI.ID
    },
    //--
    SCRN_HOU:{
      ID      : "SCRN-HOU",
      NAME    : "Housing",
      RGT_MOD : this.adminService.ACCESS_RIGHT.HOU.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.HOU.RIGHT.HOU_VIEW.ID
    },
    SCRN_SME:{
      ID      : "SCRN-SME",
      NAME    : "SME/Corporate",
      RGT_MOD : this.adminService.ACCESS_RIGHT.SME.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.SME.RIGHT.SME_VIEW.ID
    },
    //-- Cheque
    SCRN_CHQ_NEW:{
      ID      : "SCRN-CHQ-NEW",
      NAME    : "Cheque - New",
      RGT_MOD : this.adminService.ACCESS_RIGHT.CHQ.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.CHQ.RIGHT.CHQ_NEW.ID
    },
    //-- Money (without Cash)
    SCRN_CDT_VIEW:{
      ID      : "SCRN-CDT-VIEW",
      NAME    : "Money (without Cash)",
      RGT_MOD : this.adminService.ACCESS_RIGHT.CDT.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.CDT.RIGHT.CDT_VIEW.ID
    },
    //--
    SCRN_TTB:{
      ID      : "SCRN-TTB",
      NAME    : "TTB - List",
      RGT_MOD : this.adminService.ACCESS_RIGHT.TTB.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.TTB.RIGHT.TTB_VIEW.ID
    },
    SCRN_TTB_IMP:{
      ID      : "SCRN-TTB-IMP",
      NAME    : "TTB - Import",
      RGT_MOD : this.adminService.ACCESS_RIGHT.TTB.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.TTB.RIGHT.TTB_IMP.ID
    },
    //-- IBIZ
    SCRN_IBZ:{
      ID      : "SCRN-IBZ",
      NAME    : "IBIZ",
      RGT_MOD : this.adminService.ACCESS_RIGHT.IBZ.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.IBZ.RIGHT.IBZ_VIEW.ID
    },
    //-- IBIZ
    SCRN_IBZ_IMP:{
      ID      : "SCRN-IBZ-IMP",
      NAME    : "IBIZ - Import",
      RGT_MOD : this.adminService.ACCESS_RIGHT.IBZ.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.IBZ.RIGHT.IBZ_IMP.ID
    },
    //--
    SCRN_TDR_VIEW:{
      ID      : "SCRN-TDR",
      NAME    : "TDR - View",
      RGT_MOD : this.adminService.ACCESS_RIGHT.TDR.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.TDR.RIGHT.TDR_VIEW.ID
    },
    //--
    SCRN_TDR_IMP:{
      ID      : "SCRN-TDR-IMP",
      NAME    : "TDR - Import",
      RGT_MOD : this.adminService.ACCESS_RIGHT.TDR.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.TDR.RIGHT.TDR_IMP.ID
    },
    //--
    SCRN_TDR_EXP:{
      ID      : "SCRN-TDR-EXP",
      NAME    : "TDR - Export",
      RGT_MOD : this.adminService.ACCESS_RIGHT.TDR.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.TDR.RIGHT.TDR_VIEW.ID
    },
    //--
    SCRN_CEIR:{
      ID      : "SCRN-CEIR",
      NAME    : "CEIR",
      RGT_MOD : this.adminService.ACCESS_RIGHT.CEIR.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.CEIR.RIGHT.CEIR_VIEW.ID
    },
    //--
    SCRN_BANKRATE:{
      ID      : "SCRN-BANKRATE",
      NAME    : "MLR, MRR",
      RGT_MOD : this.adminService.ACCESS_RIGHT.BANK_RATE.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.BANK_RATE.RIGHT.BANKRATE_VIEW.ID
    },
    //--
    SCRN_KCC_CEIR:{
      ID      : "SCRN-KCC-CEIR",
      NAME    : "KCC CEIR",
      RGT_MOD : this.adminService.ACCESS_RIGHT.KCC_CEIR.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.KCC_CEIR.RIGHT.CEIR_VIEW.ID
    },
    //--
    SCRN_PV:{
      ID      : "SCRN-PV",
      NAME    : "PV",
      RGT_MOD : this.adminService.ACCESS_RIGHT.PV.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.PV.RIGHT.PV_VIEW.ID
    },
    //--
    SCRN_KCC_PV:{
      ID      : "SCRN-KCC-PV",
      NAME    : "KCC PV",
      RGT_MOD : this.adminService.ACCESS_RIGHT.KCC_PV.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.KCC_PV.RIGHT.PV_VIEW.ID
    },
    //--
    SCRN_ICIN:{
      ID      : "SCRN-ICIN",
      NAME    : "เงินลงทุนส่วนเพิ่ม",
      RGT_MOD : this.adminService.ACCESS_RIGHT.ICIN.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.ICIN.RIGHT.ICIN_VIEW.ID
    },
    //--------------------------------------------------------------------------------
    //-- REPORTs SCREEN 
    //--------------------------------------------------------------------------------
    SCRN_RPT_ACC:{
      ID      : "SCRN-RPT-ACC",
      NAME    : "Report - Accounting",
      RGT_MOD : this.adminService.ACCESS_RIGHT.RPT.RIGHT.ACC_RPT.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.RPT.RIGHT.ACC_RPT.ID + "," +
                this.adminService.ACCESS_RIGHT.RPT.RIGHT.ACC_RPT01.ID + "," +
                this.adminService.ACCESS_RIGHT.RPT.RIGHT.ACC_RPT02.ID + "," +
                this.adminService.ACCESS_RIGHT.RPT.RIGHT.ACC_RPT03.ID
    },
    SCRN_RPT_OPR:{
      ID      : "SCRN-RPT-OPR",
      NAME    : "Report - Operation",
      RGT_MOD : this.adminService.ACCESS_RIGHT.RPT.RIGHT.OPR_RPT.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.RPT.RIGHT.OPR_RPT.ID + "," +
                this.adminService.ACCESS_RIGHT.RPT.RIGHT.OPR_RPT01.ID + "," +
                this.adminService.ACCESS_RIGHT.RPT.RIGHT.OPR_RPT02.ID + "," +
                this.adminService.ACCESS_RIGHT.RPT.RIGHT.OPR_RPT03.ID + "," +
                this.adminService.ACCESS_RIGHT.RPT.RIGHT.OPR_RPT04.ID + "," +
                this.adminService.ACCESS_RIGHT.RPT.RIGHT.OPR_RPT05.ID + "," +
                this.adminService.ACCESS_RIGHT.RPT.RIGHT.OPR_RPT06.ID
    },
    SCRN_RPT_FIN:{
      ID      : "SCRN-RPT-FIN",
      NAME    : "Report - Financial",
      RGT_MOD : this.adminService.ACCESS_RIGHT.RPT.RIGHT.FIN_RPT.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.RPT.RIGHT.FIN_RPT.ID + "," +
                this.adminService.ACCESS_RIGHT.RPT.RIGHT.FIN_RPT01.ID
    },
    SCRN_RPT_AM:{
      ID      : "SCRN-RPT-AM",
      NAME    : "Report - Asset Management",
      RGT_MOD : this.adminService.ACCESS_RIGHT.RPT.RIGHT.AM_RPT.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.RPT.RIGHT.AM_RPT.ID
    },
    SCRN_RPT_LEG:{
      ID      : "SCRN-RPT-LEG",
      NAME    : "Report - Legal",
      RGT_MOD : this.adminService.ACCESS_RIGHT.RPT.RIGHT.LEG_RPT.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.RPT.RIGHT.LEG_RPT.ID
    },
    //-- 2022-11-17
    SCRN_RPT_NPA:{
      ID      : "SCRN-RPT-NPA",
      NAME    : "Report - NPA",
      RGT_MOD : this.adminService.ACCESS_RIGHT.RPT.RIGHT.NPA_RPT.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.RPT.RIGHT.NPA_RPT.ID + "," +
                this.adminService.ACCESS_RIGHT.RPT.RIGHT.NPA_RPT01.ID + "," +
                this.adminService.ACCESS_RIGHT.RPT.RIGHT.NPA_RPT02.ID + "," +
                this.adminService.ACCESS_RIGHT.RPT.RIGHT.NPA_RPT03.ID + "," +
                this.adminService.ACCESS_RIGHT.RPT.RIGHT.NPA_RPT04.ID + "," +
                this.adminService.ACCESS_RIGHT.RPT.RIGHT.NPA_RPT05.ID
    },
    //--------------------------------------------------------------------------------
    //-- LEGAL SCREEN 
    //--------------------------------------------------------------------------------
    SCRN_LEGAL_000:{
      ID      : "LEGAL-000",
      NAME    : "Dashboard",
      RGT_MOD : this.adminService.ACCESS_RIGHT.LEGAL.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.LEGAL.RIGHT.LEGAL_000.ID
    },
    SCRN_LEGAL_001:{
      ID      : "LEGAL-001",
      NAME    : "รับเอกสารฉบับจริง",
      RGT_MOD : this.adminService.ACCESS_RIGHT.LEGAL.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.LEGAL.RIGHT.LEGAL_001.ID
    },
    //--
    SCRN_LEGAL_002:{
      ID      : "LEGAL-002",
      NAME    : "ส่งหนังสือบอกกล่าวฯ",
      RGT_MOD : this.adminService.ACCESS_RIGHT.LEGAL.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.LEGAL.RIGHT.LEGAL_002.ID
    },
    //--
    SCRN_LEGAL_003:{
      ID      : "LEGAL-003",
      NAME    : "โอนสิทธิการรับจำนอง",
      RGT_MOD : this.adminService.ACCESS_RIGHT.LEGAL.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.LEGAL.RIGHT.LEGAL_003.ID
    },
    //--
    SCRN_LEGAL_004:{
      ID      : "LEGAL-004",
      NAME    : "ยื่นสวมสิทธิในคดี",
      RGT_MOD : this.adminService.ACCESS_RIGHT.LEGAL.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.LEGAL.RIGHT.LEGAL_004.ID
    },
    //--
    SCRN_LEGAL_01:{
      ID      : "LEGAL-01",
      NAME    : "ยังไม่ฟ้อง",
      RGT_MOD : this.adminService.ACCESS_RIGHT.LEGAL.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.LEGAL.RIGHT.LEGAL_01.ID
    },
    //--
    SCRN_LEGAL_02:{
      ID      : "LEGAL-02",
      NAME    : "ฟ้องคดี",
      RGT_MOD : this.adminService.ACCESS_RIGHT.LEGAL.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.LEGAL.RIGHT.LEGAL_02.ID
    },
    //--
    SCRN_LEGAL_03:{
      ID      : "LEGAL-03",
      NAME    : "พิพากษา",
      RGT_MOD : this.adminService.ACCESS_RIGHT.LEGAL.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.LEGAL.RIGHT.LEGAL_03.ID
    },
    //--
    SCRN_LEGAL_041:{
      ID      : "LEGAL-041",
      NAME    : "อุทธรณ์",
      RGT_MOD : this.adminService.ACCESS_RIGHT.LEGAL.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.LEGAL.RIGHT.LEGAL_041.ID
    },
    //--
    SCRN_LEGAL_042:{
      ID      : "LEGAL-042",
      NAME    : "ฎีกา",
      RGT_MOD : this.adminService.ACCESS_RIGHT.LEGAL.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.LEGAL.RIGHT.LEGAL_042.ID
    },
    //--
    SCRN_LEGAL_X:{
      ID      : "LEGAL-X",
      NAME    : "เจ้าหนี้นอก",
      RGT_MOD : this.adminService.ACCESS_RIGHT.LEGAL.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.LEGAL.RIGHT.LEGAL_X.ID
    },
    //--
    SCRN_LEGAL_05:{
      ID      : "LEGAL-05",
      NAME    : "บังคับคดี",
      RGT_MOD : this.adminService.ACCESS_RIGHT.LEGAL.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.LEGAL.RIGHT.LEGAL_05.ID
    },
    //--
    SCRN_LEGAL_06:{
      ID      : "LEGAL-06",
      NAME    : "ประกาศขาย",
      RGT_MOD : this.adminService.ACCESS_RIGHT.LEGAL.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.LEGAL.RIGHT.LEGAL_06.ID
    },
    //--
    SCRN_LEGAL_07:{
      ID      : "LEGAL-07",
      NAME    : "ขายได้",
      RGT_MOD : this.adminService.ACCESS_RIGHT.LEGAL.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.LEGAL.RIGHT.LEGAL_07.ID
    },
    //--
    SCRN_LEGAL_08:{
      ID      : "LEGAL-08",
      NAME    : "รับเงินแล้ว",
      RGT_MOD : this.adminService.ACCESS_RIGHT.LEGAL.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.LEGAL.RIGHT.LEGAL_08.ID
    },
    //--
    SCRN_LEGAL_09:{
      ID      : "LEGAL-09",
      NAME    : "ทรัพย์ NPA",
      RGT_MOD : this.adminService.ACCESS_RIGHT.LEGAL.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.LEGAL.RIGHT.LEGAL_09.ID
    },
    //--
    SCRN_LEGAL_10:{
      ID      : "LEGAL-10",
      NAME    : "สืบทรัพย์",
      RGT_MOD : this.adminService.ACCESS_RIGHT.LEGAL.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.LEGAL.RIGHT.LEGAL_10.ID
    },
    //--
    SCRN_LEGAL_11:{
      ID      : "LEGAL-11",
      NAME    : "ฟ้องส่วนต่าง",
      RGT_MOD : this.adminService.ACCESS_RIGHT.LEGAL.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.LEGAL.RIGHT.LEGAL_11.ID
    },
    //--
    SCRN_LEGAL_12:{
      ID      : "LEGAL-12",
      NAME    : "ปิดบัญชี",
      RGT_MOD : this.adminService.ACCESS_RIGHT.LEGAL.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.LEGAL.RIGHT.LEGAL_12.ID
    },
    //--
    SCRN_LEGAL_NOTE:{
      ID      : "LEGAL-NOTE",
      NAME    : "บันทึกเพิ่มเติม",
      RGT_MOD : this.adminService.ACCESS_RIGHT.LEGAL.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.LEGAL.RIGHT.LEGAL_NOTE.ID
    },
    //-- ----------------------------------------------------------------------
    //-- COLATERAL
    //-- ----------------------------------------------------------------------
    SCRN_CLT_LIST:{
      ID      : "CLT-LIST",
      NAME    : "Colateral List",
      RGT_MOD : this.adminService.ACCESS_RIGHT.COLLATERAL.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.COLLATERAL.RIGHT.CLT_LIST.ID
    },
    SCRN_CLT_DETAIL:{
      ID      : "CLT-DETL",
      NAME    : "Colateral Detail",
      RGT_MOD : this.adminService.ACCESS_RIGHT.COLLATERAL.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.COLLATERAL.RIGHT.CLT_DETAIL.ID
    },
    SCRN_CLT_REDEEM:{
      ID      : "CLT-RDM",
      NAME    : "Colateral - ไถ่ถอน (จ่ายเงินปิด)",
      RGT_MOD : this.adminService.ACCESS_RIGHT.COLLATERAL.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.COLLATERAL.RIGHT.CLT_REDEEM.ID
    },
    SCRN_CLT_SELL:{
      ID      : "CLT-SELL",
      NAME    : "Colateral - ไถ่ถอน (ขายทอดตลาด)",
      RGT_MOD : this.adminService.ACCESS_RIGHT.COLLATERAL.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.COLLATERAL.RIGHT.CLT_SELL.ID
    },
    SCRN_CLT_CONVERT:{
      ID      : "CLT-CVT",
      NAME    : "Colateral - ตีทรัพย์ชำระหนี้",
      RGT_MOD : this.adminService.ACCESS_RIGHT.COLLATERAL.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.COLLATERAL.RIGHT.CLT_CONVERT.ID
    },
    SCRN_CLT_TO_NPA:{
      ID      : "CLT-TO-NPA",
      NAME    : "Colateral - to NPA",
      RGT_MOD : this.adminService.ACCESS_RIGHT.COLLATERAL.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.COLLATERAL.RIGHT.CLT_TO_NPA.ID
    },
    //-- ----------------------------------------------------------------------
    //-- NPA  
    //-- ----------------------------------------------------------------------
    SCRN_NPA_LIST:{
      ID      : "NPA-LIST",
      NAME    : "NPA List",
      RGT_MOD : this.adminService.ACCESS_RIGHT.NPA.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.NPA.RIGHT.NPA_LIST.ID
    },
    SCRN_NPA_DETAIL:{
      ID      : "NPA-DETL",
      NAME    : "NPA Detail",
      RGT_MOD : this.adminService.ACCESS_RIGHT.NPA.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.NPA.RIGHT.NPA_DETAIL.ID
    },
    SCRN_NPA_TRAN:{
      ID      : "NPA-TRAN",
      NAME    : "NPA Transfer",
      RGT_MOD : this.adminService.ACCESS_RIGHT.NPA.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.NPA.RIGHT.NPA_TRAN.ID
    },
    //-- ----------------------------------------------------------------------
    //-- Request
    //-- ----------------------------------------------------------------------
    SCRN_REQ_WAV_DEF:{
      ID      : "REQ-WAV-DEF",
      NAME    : "Request - Waive ผิดนัด",
      RGT_MOD : this.adminService.ACCESS_RIGHT.REQ.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.REQ.RIGHT.WAV_DEF.ID
    },
    SCRN_REQ_CLS_ACC:{
      ID      : "REQ-CLS-ACC",
      NAME    : "Request - ปิดบัญชี",
      RGT_MOD : this.adminService.ACCESS_RIGHT.REQ.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.REQ.RIGHT.CLS_ACC.ID
    },
    SCRN_REQ_NEW_PF:{
      ID      : "REQ-NEW-PF",
      NAME    : "Request - เพิ่ม Portfolio",
      RGT_MOD : this.adminService.ACCESS_RIGHT.REQ.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.REQ.RIGHT.NEW_PF.ID
    },
    SCRN_REQ_IMP_DT:{
      ID      : "REQ-IMP-DT",
      NAME    : "Request - Import Debtor data",
      RGT_MOD : this.adminService.ACCESS_RIGHT.REQ.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.REQ.RIGHT.IMP_DT.ID
    },
    SCRN_REQ_IMP_CLT:{
      ID      : "REQ-IMP-CLT",
      NAME    : "Request - Import Collateral data",
      RGT_MOD : this.adminService.ACCESS_RIGHT.REQ.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.REQ.RIGHT.IMP_CLT.ID
    },
    SCRN_REQ_CANCEL_RECP:{
      ID      : "REQ-CANCEL-RECP",
      NAME    : "Request - ยกเลิกเลขที่ใบเสร็จ",
      RGT_MOD : this.adminService.ACCESS_RIGHT.REQ.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.REQ.RIGHT.CANCEL_RECP.ID
    },
    //-- ----------------------------------------------------------------------
    //-- Approve  
    //-- ----------------------------------------------------------------------
    SCRN_APV_WAV_DEF:{
      ID      : "APV-WAV-DEF",
      NAME    : "Approve - Waive ผิดนัด",
      RGT_MOD : this.adminService.ACCESS_RIGHT.APPROVE.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.APPROVE.RIGHT.WAV_DEF.ID
    },
    SCRN_APV_CLS_ACC:{
      ID      : "APV-CLS-ACC",
      NAME    : "Approve - ปิดบัญชี",
      RGT_MOD : this.adminService.ACCESS_RIGHT.APPROVE.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.APPROVE.RIGHT.CLS_ACC.ID
    },
    SCRN_APV_CLS_CLT:{
      ID      : "APV-CLS-CLT",
      NAME    : "Approve - จ่ายเงินปิด",
      RGT_MOD : this.adminService.ACCESS_RIGHT.APPROVE.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.APPROVE.RIGHT.CLS_CLT.ID
    },
    SCRN_APV_CLT_TO_MONEY:{
      ID      : "APV-CLT-TO-MONEY",
      NAME    : "Approve - ตีทรัพย์ชำระหนี้",
      RGT_MOD : this.adminService.ACCESS_RIGHT.APPROVE.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.APPROVE.RIGHT.CLT_TO_MONEY.ID
    },
    SCRN_APV_CLT_TO_NPA:{
      ID      : "APV-CLT-TO-NPA",
      NAME    : "Approve - ยกซื้อ NPA",
      RGT_MOD : this.adminService.ACCESS_RIGHT.APPROVE.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.APPROVE.RIGHT.CLT_TO_NPA.ID
    },
    SCRN_APV_SELL_CLT:{
      ID      : "APV-SELL-CLT",
      NAME    : "Approve - ขายทอดตลาด",
      RGT_MOD : this.adminService.ACCESS_RIGHT.APPROVE.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.APPROVE.RIGHT.SELL_CLT.ID
    },
    SCRN_APV_NEW_PF:{
      ID      : "APV-NEW-PF",
      NAME    : "Approve - เพิ่ม Portfolio",
      RGT_MOD : this.adminService.ACCESS_RIGHT.APPROVE.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.APPROVE.RIGHT.NEW_PF.ID
    },
    SCRN_APV_IMP_DT:{
      ID      : "APV-IMP-DT",
      NAME    : "Approve - Import Debtor data",
      RGT_MOD : this.adminService.ACCESS_RIGHT.APPROVE.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.APPROVE.RIGHT.IMP_DT.ID
    },
    SCRN_APV_IMP_CLT:{
      ID      : "APV-IMP-CLT",
      NAME    : "Approve - Import Collateral data",
      RGT_MOD : this.adminService.ACCESS_RIGHT.APPROVE.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.APPROVE.RIGHT.IMP_CLT.ID
    },
    SCRN_APV_CANCEL_RECP:{
      ID      : "APV-CANCEL-RECP",
      NAME    : "Approve - ยกเลิกเลขที่ใบเสร็จ",
      RGT_MOD : this.adminService.ACCESS_RIGHT.APPROVE.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.APPROVE.RIGHT.CANCEL_RECP.ID
    },
    //--
    //-- ----------------------------------------------------------------------
    //-- Application  
    //-- ----------------------------------------------------------------------
    SCRN_APP_USR:{
      ID      : "SCRN-APP-USR",
      NAME    : "Application - User",
      RGT_MOD : this.adminService.ACCESS_RIGHT.APP.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.APP.RIGHT.APP_USR.ID
    },
    SCRN_APP_NOTI:{
      ID      : "SCRN-APP-NOTI",
      NAME    : "Application - Notification",
      RGT_MOD : this.adminService.ACCESS_RIGHT.APP.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.APP.RIGHT.APP_NOTI.ID
    },
    SCRN_APP_NEW_NOTI:{
      ID      : "SCRN-APP-NEW-NOTI",
      NAME    : "Application - New Notification",
      RGT_MOD : this.adminService.ACCESS_RIGHT.APP.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.APP.RIGHT.APP_NOTI.ID
    },
    SCRN_APP_CHAT:{
      ID      : "SCRN-APP-CHAT",
      NAME    : "Application - Chat",
      RGT_MOD : this.adminService.ACCESS_RIGHT.APP.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.APP.RIGHT.APP_CHAT.ID
    },
    SCRN_APP_USR_GRP:{
      ID      : "SCRN-APP-GRP",
      NAME    : "Application - User group",
      RGT_MOD : this.adminService.ACCESS_RIGHT.APP.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.APP.RIGHT.APP_GRP.ID
    },
    SCRN_APP_GRP_MEM:{
      ID      : "SCRN-APP-MEM",
      NAME    : "Application - Group Member",
      RGT_MOD : this.adminService.ACCESS_RIGHT.APP.TITLE,
      RGT_ID  : this.adminService.ACCESS_RIGHT.APP.RIGHT.APP_MEM.ID
    },
  }


  //-- log on bottom of page -- 24/09/2023
  logTableTitle = [
    "Action", "note", "by", "code", "action time"
  ];
  logTableDisplayedColumns = [ 
    'T_LOG_TITLE', 
    'T_LOG_DETL1',
    'T_LOG_BY',
    'T_LOG_ACTION', 
    'T_CRT_DATE'
  ];

  // LOG_LEVEL = {
  //   INFO : {
  //     ID    : "INFO",
  //     TITLE : "Information"
  //   },
  //   WARNING : {
  //     ID    : "WARNING",
  //     TITLE : "Warning"
  //   }
  // }
  //-- ~
  //-- ===============================================================================================
  //-- ~ SERVICE : Insert user log
  //-- ===============================================================================================
  log(
    ACTION    : String,
    SCRN_ID   : String,
    LOG_TITLE : String,
    LOG_BY    : String,
    LOG_DETL1 ?: String,
    LOG_DETL2 ?: String,
    LOG_DETL3 ?: String,
    LOG_DETL4 ?: String,
    LOG_NOTE  ?: String,
  ){

    var logObj = {};

    logObj["LOG_ACTION"] = ACTION.trim();
    logObj["SCRN_ID"   ] = SCRN_ID;
    logObj["LOG_TITLE" ] = LOG_TITLE.trim();
    logObj["LOG_DETL1" ] = ( LOG_DETL1 ) ? LOG_DETL1.trim() : "";
    logObj["LOG_DETL2" ] = ( LOG_DETL2 ) ? LOG_DETL2.trim() : "";
    logObj["LOG_DETL3" ] = ( LOG_DETL3 ) ? LOG_DETL3.trim() : "";
    logObj["LOG_DETL4" ] = ( LOG_DETL4 ) ? LOG_DETL4.trim() : "";
    logObj["LOG_BY"    ] = ( LOG_BY    ) ? LOG_BY.trim()    : "";
    logObj["LOG_NOTE"  ] = ( LOG_NOTE  ) ? LOG_NOTE.trim()  : "";
    logObj["CRT_USER"  ] = this.SYSTEM;
    logObj["UPD_USER"  ] = this.SYSTEM;
    
    // console.log( "add log", logObj );

    this.http.post('/ulog', logObj)
      .subscribe(res => {
        return true;
      }, (err) => {
        console.log(err);
        return false;
      }
    );
    return true;

  }
  //-- ~ END : log()
  //-- =====================================================
  logAccess(
    SCRN_ID   : any,
    LOG_BY    ?: String,
    LOG_DETL1 ?: String,
    LOG_DETL2 ?: String,
    LOG_DETL3 ?: String,
    LOG_DETL4 ?: String,
    LOG_NOTE  ?: String,
  ){
    if( !LOG_BY ){
      LOG_BY = this.profile["email"];
    }
    return this.log( 
      this.LOG_ACTION.ACCESS, SCRN_ID, "Access screen", LOG_BY,
      LOG_DETL1, LOG_DETL2, LOG_DETL3, LOG_DETL4, LOG_NOTE
    );
  }
  //-- ~ END : logAccess()
  //-- =====================================================
  isAllowAccess( rightId ){
    var isAllow  = false;
    console.log("isAllowAccess-- in", rightId);
    var rightObj = this.profile[ "U_RIGHT" ];
    
    if( rightObj[ rightId ] ){
      isAllow = true;
    }
    console.log("isAllowAccess",rightId,isAllow);
   
    return isAllow;
  }
  //-- ~ END : isAllowAccess()
  //-- =====================================================
  getScreenName( screenId ){
    var screenName = "";
    for( var x in this.SCREEN ){
      if( this.SCREEN[ x ].ID == screenId ){
        return this.SCREEN[ x ].NAME;
      }
    }
    return screenName;
  }
  //-- ===============================================================================================
  //-- ~ SERVICE : Insert user log
  //-- ===============================================================================================



  //-- ~
  //-- =====================================================
  //-- =====================================================
  //-- ==================================
  //-- insert AUDIT LOG 
  //-- ==================================
  insertLogAudit( aUserEmail, aLogType, aLogDetail1, aLogDetail2, aLogDetail3, aLogDetail4, aLogDetail5 ){
    //-- log a
    var log = {};
    log["A_EMAIL"]      = aUserEmail.trim();
    log["A_LOG_TYPE"]   = aLogType.trim();
    log["A_LOG_DETL_1"] = aLogDetail1.trim();
    log["A_LOG_DETL_2"] = aLogDetail2.trim();
    log["A_LOG_DETL_3"] = aLogDetail3.trim();
    log["A_LOG_DETL_4"] = aLogDetail4.trim();
    log["A_LOG_DETL_5"] = aLogDetail5.trim();

    log["CRT_USER"]  = "SYSTEM";
    this.http.post('/loga', log)
      .subscribe(res => {
        return true;
      }, (err) => {
        console.log(err);
        return false;
      }
    );
    return true;
  }
  //-- ==================================
  //-- get AUDIT LOG
  //-- ==================================
  getLogAudit( aLogType ): void { 
  
      this.http.get( "/loga/x/" + aLogType ).subscribe( data => {
          
        return data;

      });
  }
  //-- =====================================================
  //-- =====================================================
  //-- ==================================
  //-- insert LOG A
  //-- ==================================
  insertLogA( aUserEmail, aLogType, aLogDetail1, aLogDetail2, aLogDetail3, aLogDetail4, aLogDetail5 ){
    //-- log a
    var log = {};
    log["A_EMAIL"]      = aUserEmail.trim();
    log["A_LOG_TYPE"]   = aLogType.trim();
    log["A_LOG_DETL_1"] = aLogDetail1.trim();
    log["A_LOG_DETL_2"] = aLogDetail2.trim();
    log["A_LOG_DETL_3"] = aLogDetail3.trim();
    log["A_LOG_DETL_4"] = aLogDetail4.trim();
    log["A_LOG_DETL_5"] = aLogDetail5.trim();

    log["CRT_USER"]  = "SYSTEM";
    this.http.post('/loga', log)
      .subscribe(res => {
        return true;
      }, (err) => {
        console.log(err);
        return false;
      }
    );
    return true;
  }
  //-- ==================================
  //-- get LOG A
  //-- ==================================
  getLogA( aLogType ): void { 
  
      this.http.get( "/loga/x/" + aLogType ).subscribe( data => {
          
        return data;

      });
  }
  //-- ==================================
  //-- ~ Message
  //-- ==================================
  openSnackBar( message: string, action: string ) {
    this.snackBar.open( message, action, {
      duration: 2000,
    });
  }
  //-- =====================================================
  //-- =====================================================
  

}
